module.exports = __webpack_public_path__ + "img/504.dfda1a78.png";